import { render, staticRenderFns } from "./PhysicalActivitiesEnterprise.vue?vue&type=template&id=23108d15"
import script from "./PhysicalActivitiesEnterprise.vue?vue&type=script&lang=js"
export * from "./PhysicalActivitiesEnterprise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports